import { useEffect } from 'react';
import { usePaletteContext } from '../contexts/PaletteContext';
import { useToolInit } from '../hooks/useToolInit';
import { FitnessScorePanel } from '../components/FitnessScorePanel';
import { PalettePicker } from '../components/PalettePicker';
import { PanelHeader } from '../components/shell/PanelHeader';

export function ScoreTool() {
  const { params } = useToolInit();
  const { currentPalette, palettes, setCurrentPalette } = usePaletteContext();

  // Deep-link: ?palette=<id>
  useEffect(() => {
    if (params.palette && palettes.length > 0) {
      const match = palettes.find(p => p.id === params.palette);
      if (match) setCurrentPalette(match);
    }
  }, [params.palette, palettes, setCurrentPalette]);

  if (!currentPalette) {
    return (
      <>
        <PanelHeader
          title="Palette Score"
          subtitle="Evaluate how well a palette works for a specific use case"
        />
        <PalettePicker prompt="Select a palette to score" />
      </>
    );
  }

  return (
    <>
      <PanelHeader
        title="Palette Score"
        subtitle={`Evaluating "${currentPalette.name}" (${currentPalette.colors.length} colors)`}
      />
      <FitnessScorePanel colors={currentPalette.colors} />
    </>
  );
}
